import { Middleware, MiddlewareAPI, UnknownAction } from "@reduxjs/toolkit";

import { saveConfigToServerThunk } from "@/store/thunks";
import { AppDispatch, RootState } from "@/store/types";

export const configTrackingMiddleware: Middleware = (() => {
    let timeoutId: NodeJS.Timeout | null = null;
    const DEBOUNCE_MS = 2000;

    return (store: MiddlewareAPI<AppDispatch, RootState>) =>
        (next) =>
        (action: UnknownAction) => {
            const result = next(action);

            if (action.type.startsWith("config/")) {
                if (timeoutId) clearTimeout(timeoutId);

                timeoutId = setTimeout(() => {
                    store.dispatch(saveConfigToServerThunk());
                    timeoutId = null;
                }, DEBOUNCE_MS);
            }

            return result;
        };
})();
